import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GroupsApiService } from '@core/services/groups-api.service';
import { ToastService } from '@shared/services/toast.service';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import {
  resendEmailConfirmation,
  resendEmailConfirmationFailure,
  resendEmailConfirmationSuccess,
} from '../actions/resend-email-confirmation.actions';

@Injectable()
export class ResendEmailConfirmationEffects {
  constructor(
    private actions$: Actions,
    private groupsApiService: GroupsApiService,
    private toastService: ToastService,
  ) {}

  resendEmailConfirmation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(resendEmailConfirmation),
      switchMap((action) => {
        return this.groupsApiService.resendEmailConfirmation(action.group_id, action.email).pipe(
          map(() => {
            return resendEmailConfirmationSuccess();
          }),
          catchError((error) => {
            return of(resendEmailConfirmationFailure({ error }));
          }),
        );
      }),
    ),
  );

  resendEmailConfirmationSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(resendEmailConfirmationSuccess),
        tap(() => {
          this.toastService.showToast('success', 'Confirmation link has been sent.', 3000);
        }),
      ),
    { dispatch: false },
  );

  resendEmailConfirmationFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(resendEmailConfirmationFailure),
        tap(() => {
          this.toastService.showToast('error', "Couldn't send a confirmation link, please try again later.", 10000);
        }),
      ),
    { dispatch: false },
  );
}
